import withIntersectionDetection from './withIntersectionDetection.jsx';
import ProductsListItem from './ProductsListItem.jsx';

export default withIntersectionDetection(ProductsListItem);
